export default __webpack_public_path__ + "static/media/talent_overview.e8ec2179.svg";